import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { LoadingAnimation } from '../ui/loadingAnimation/LoadingAnimation';

export const DashboardLoading = () => {
    return (
        <div className="m-auto flex w-full flex-col items-center justify-center bg-structure-100 pt-5xl">
            <LoadingAnimation data-testid="loading-spinner" />
            <Text className="text-l font-med">
                <FormattedMessage
                    id="_.dashboard.loading_text"
                    defaultMessage="Checking your details"
                />
            </Text>
        </div>
    );
};
